module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--messaging main--full-height"
  }, [_c('div', {
    staticClass: "appointments messaging group group--first-last"
  }, [_c('div', {
    staticClass: "appointments__content"
  }, [_c('h1', {
    staticClass: "c-accent appointments__title",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Shared documents")]), _vm._v(" "), (_vm.documents && _vm.documents.length <= 0) ? _c('p', {
    staticClass: "mt2 pt2 p xlarge fw-regular"
  }, [_vm._v("You don't have any documents.")]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "appointments__table"
  }, _vm._l((_vm.formatDocuments), function(document) {
    return _c('div', {
      key: document.id,
      staticClass: "table cp",
      on: {
        "click": function($event) {
          return _vm.generateFile(document.mime_type, document.id)
        }
      }
    }, [_c('div', {
      staticClass: "table__column df aic"
    }, [_c('img', {
      staticClass: "defaultimage",
      attrs: {
        "src": _vm.Default_image,
        "alt": "Default_image"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "document-name",
      attrs: {
        "title": document.document_name
      }
    }, [_vm._v(_vm._s(document.document_name))])]), _vm._v(" "), _c('div', {
      staticClass: "table__column mr2"
    }, [_c('p', [_vm._v(_vm._s(document.upload_by))])]), _vm._v(" "), _c('div', {
      staticClass: "table__column"
    }, [_c('p', [_vm._v(_vm._s(_vm.formatTime(document.upload_date)))])])])
  }), 0)])]), _vm._v(" "), _c('module-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openModal),
      expression: "openModal"
    }],
    attrs: {
      "modal": _vm.modalData
    },
    on: {
      "close": function($event) {
        _vm.openModal = false
      }
    }
  }, [_c('template', {
    slot: "modal-body"
  }, [_c('div', [_c('p', {
    staticClass: "pt"
  }, [_vm._v("Please log in from a laptop or desktop to download this file.")])])]), _vm._v(" "), _c('template', {
    slot: "modal-footer"
  }, [_c('module-button', {
    nativeOn: {
      "click": function($event) {
        _vm.openModal = false
      }
    }
  }, [_vm._v("Close")])], 1)], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appointments__header"
  }, [_c('h3', [_vm._v("Document")]), _vm._v(" "), _c('h3', [_vm._v("From")]), _vm._v(" "), _c('h3', [_vm._v("Date")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42b53b3e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/documents/Documents.vue
// module id = 525
// module chunks = 0